import { RefObject, useEffect } from "react";

export function useOutsideClick(
  ref: RefObject<HTMLElement | null>,
  handler: () => void
) {
  useEffect(() => {
    function handlePointerDown(event: MouseEvent) {
      const target = event.target as Element | null;
      if (!ref.current || !target || !target.isConnected) return;
      if (ref.current.contains(target)) return;
      if (target.closest("[data-radix-popper-content-wrapper]")) return;
      handler();
    }
    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [ref, handler]);
}
